export class Toaster {
    constructor(toastContainerSelector) {
        this.toastContainerEl = document.querySelector(toastContainerSelector);
        this.closedToasts = this.getClosedToasts();
        this.toastContainerEl.addEventListener("click", (e) => {
            if (e.target.matches(".delete")) {
                this.closeToast(e.target.closest(".toast"));
            }
        });
    }

    getClosedToasts() {
        this.closedToasts = localStorage.getItem("closedToasts") ? JSON.parse(localStorage.getItem("closedToasts")) : [];
        return this.closedToasts;
    }

    addToastIdToClosed(toastId) {
        const closedToasts = this.getClosedToasts();
        closedToasts.push(toastId);
        localStorage.setItem("closedToasts", JSON.stringify(closedToasts))
    }

    buildToast(msg, toastId, initialState="loading") {
        const toastHtml = `
                            <div data-toast-id="${toastId}" data-toast-state="${initialState}" class="toast notification is-loading is-inline-flex is-inactive">
                                <button type="button" class="delete is-small"></button>
                                <div class="toast-state-container">
                                    <div data-toast-state-name="loading" class="toast-state ${initialState==="loading" ? "" : "is-inactive"}">
                                        <div class="is-flex-grow-0 is-loading-zeta"></div>
                                    </div>
                                    <div data-toast-state-name="failed" class="toast-state ${initialState=== "failed" ? "" : "is-inactive"}">
                                        <span class="icon"><i class="fas fa-circle-xmark"></i></span>
                                    </div>
                                    <div data-toast-state-name="success" class="toast-state ${initialState=== "success" ? "" : "is-inactive"}">
                                        <span class="icon"><i class="fas fa-circle-check"></i></span>
                                    </div>
                                </div>
                                <div>${msg}</div>
                            </div>
                           `.trim();
        const parser = new DOMParser();
        const doc = parser.parseFromString(toastHtml, "text/html");
        const toast = doc.body.firstElementChild;
        return toast;
    }

    appendToast(msg, toastId, preventDuplicates=true) {
        if (this.getClosedToasts().includes(toastId) && preventDuplicates) return;
        if (this.getToastEls().map((el) => el.dataset.toastId).includes(toastId) && preventDuplicates) return;
        // const oldToasts = Array.from(this.toastContainerEl.children)
        const el = this.buildToast(msg, toastId);
        this.flipToast(el)
    }

    getToastEls() {
        return Array.from(this.toastContainerEl.children)
    }

    closeToast(el, stateChange=null) {
        if (stateChange) {
            el.dataset.toastState = stateChange;
            const toastStateContainer = el.querySelector(".toast-state-container");
            Array.from(toastStateContainer.children).forEach((toastStateEl) => {
                toastStateEl.classList.toggle("is-inactive", toastStateEl.dataset.toastStateName !== stateChange)
            })
        }

        setTimeout(() => {
            el.classList.add("is-removed");
            setTimeout(() => {
                el.remove();
            }, 200);
        }, stateChange === null ? 0 : 2000)

        if (el.dataset.toastId) {
            this.addToastIdToClosed(el.dataset.toastId);
        }
    }

    flipToast(toast) {
        // FIRST
        const first = this.toastContainerEl.offsetHeight

        // add new child to change container size
        this.toastContainerEl.append(toast)
        setTimeout(() => {
            toast.classList.remove("is-inactive");
        }, 0)


        // LAST
        const last = this.toastContainerEl.offsetHeight

        // INVERT
        const invert = last - first

        // PLAY
        const animation = this.toastContainerEl.animate([
            { transform: `translateY(${invert}px)` },
            { transform: 'translateY(0)' }
        ], {
            duration: 200,
            easing: 'ease-in-out',
        })
    }
}
